import { createContext, useContext, type ReactNode } from 'react';
import type {
  IDataService,
  IAuthService,
  IStorageService,
} from '@erp/data-access/interfaces';

interface ServiceContextValue {
  dataService: IDataService;
  authService: IAuthService;
  storageService: IStorageService;
}

const ServiceContext = createContext<ServiceContextValue | null>(null);

export function ServiceProvider({
  children,
  services,
}: {
  children: ReactNode;
  services: ServiceContextValue;
}) {
  return <ServiceContext.Provider value={services}>{children}</ServiceContext.Provider>;
}

export function useDataService(): IDataService {
  const ctx = useContext(ServiceContext);
  if (!ctx) throw new Error('useDataService must be used within ServiceProvider');
  return ctx.dataService;
}

export function useAuthService(): IAuthService {
  const ctx = useContext(ServiceContext);
  if (!ctx) throw new Error('useAuthService must be used within ServiceProvider');
  return ctx.authService;
}

export function useStorageService(): IStorageService {
  const ctx = useContext(ServiceContext);
  if (!ctx) throw new Error('useStorageService must be used within ServiceProvider');
  return ctx.storageService;
}
